import React from 'react';
//
import { useFetch } from 'utils';
import Loading from 'shared/loading';
//
import BlackList from './blacklist';
import Feed from './feed';
//
export default ({ username, use_instagram_black_list }) => {
  const fetchUrl = `https://www.instagram.com/${username}/?__a=1`;
  const { response, error } = useFetch(fetchUrl);

  if (error) {
    console.log({ error });
    return null;
  }

  if (!response) {
    return <Loading />;
  }

  let items = [];

  try {
    items = response.data.graphql.user.edge_owner_to_timeline_media.edges;
  } catch (parseError) {
    console.log({ parseError });
    return null;
  }

  if (!items || items.length < 1) {
    return null;
  }

  // Filter black listed items
  if (use_instagram_black_list) {
    return <BlackList items={items} username={username} />;
  }

  return <Feed items={items} />;
};
